import React from 'react';
import PropTypes from 'prop-types';

import { useLimit, useImageRequest } from './hooks';

const ImageRequest = ({ url, limit, render }) => {
  useLimit({ limit });
  const [ src, error ] = useImageRequest({ url });
  return render({ src, error });
};

ImageRequest.defaultProps = {
  render: () => null,
};

ImageRequest.propTypes = {
  url: PropTypes.string,
  render: PropTypes.func,
  limit: PropTypes.number,
};

export default ImageRequest;
